import { OnInit } from '@angular/core';
import { AlertPaymentService } from '../shared/services/alert-payment.service';
import { isCurrentRouteBlocked } from '../../../old-crazy-web-frontend/src/app/auth/blocked-state-routes';
var NewAppComponent = /** @class */ (function () {
    function NewAppComponent(alertPaymentService) {
        this.alertPaymentService = alertPaymentService;
    }
    NewAppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.alertPaymentService.onActivatePaymentAlert.subscribe(function (isPaymentFailed) {
            _this.failedPayment = isPaymentFailed;
        });
    };
    Object.defineProperty(NewAppComponent.prototype, "blurred", {
        get: function () {
            return isCurrentRouteBlocked();
        },
        enumerable: true,
        configurable: true
    });
    return NewAppComponent;
}());
export { NewAppComponent };
